import { render, staticRenderFns } from "./ui-lang-choice.vue?vue&type=template&id=ef7dcb8a&scoped=true&"
import script from "./ui-lang-choice.vue?vue&type=script&lang=js&"
export * from "./ui-lang-choice.vue?vue&type=script&lang=js&"
import style0 from "./ui-lang-choice.vue?vue&type=style&index=0&id=ef7dcb8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7dcb8a",
  null
  
)

export default component.exports